import {IEmployeeVm, ILocationVm, ProxyContainer} from '../Data/Data';
import {EmployeeDataService} from './EmployeeDataService';
import {AuthenticationService} from './AuthenticationService';

export class TerminalSessionService {

  static serviceId = 'TerminalSessionService';
  static $inject = [
    '$proxy',
    '$interval',
    EmployeeDataService.serviceId,
    AuthenticationService.serviceId
  ];

  static LoginTimeout = 15000;

  loggedIn: boolean = false;
  paused: boolean = false;
  logoutTime: number;
  employee: IEmployeeVm;
  location: ILocationVm;

  constructor(private $proxy: ProxyContainer,
              private $interval: ng.IIntervalService,
              private employeeData: EmployeeDataService,
              private authentication: AuthenticationService) {
    $interval(() => this.tick(), 1000);
  }

  async newSession(employeeNumb: number) {

    console.log(employeeNumb);
    this.employee = await this.employeeData.loadByExternalId(employeeNumb);

    if (this.employee === null) {
      alert(`Employee ${employeeNumb} not found`);
      return;
    }

    this.location = this.authentication.appUser.location;

    this.loggedIn = true;
    this.logoutTime = TerminalSessionService.LoginTimeout;

  }

  public canSelectType(): boolean {
    return this.authentication.appUser.timeEntryTypeSelectable;
  }

  public getDefaultEntryTypeId(): number {
    return this.authentication.appUser.defaultEntryTypeId;
  }

  private tick() {
    if (this.paused) {
      return;
    }

    if (this.logoutTime > 0) {
      this.logoutTime = Math.max(this.logoutTime - 1000, 0);
    }

    if (this.loggedIn && this.logoutTime === 0) {
      this.loggedIn = false;
      this.employee = null;
    }
  }


  logout() {
    this.employee = null;
    this.loggedIn = false;
  }

  extendLogoutTimeout() {
    if (!this.loggedIn) {
      return;
    }

    this.logoutTime = TerminalSessionService.LoginTimeout;
  }

  pause() {
    this.paused = true;
  }

  continue() {
    this.paused = false;
  }
}
